import { T, LocaleContext } from "../localization";
import * as React from "react";
import { Link, NavLink } from "react-router-dom";
import { FiHeadphones } from "react-icons/fi";

const HeadphonesIcon: any = FiHeadphones;

interface SideMenuProps {}

interface SideMenuState {}

class SideMenu extends React.Component<SideMenuProps, SideMenuState> {
  static contextType = LocaleContext;
  context!: React.ContextType<typeof LocaleContext>;
  state = {};
  render() {
    return (
      <>
        <div className="flex-none flex flex-col side-nav">
          <NavLink
            className={({ isActive }) =>
              isActive
                ? "flex flex-col nav-btn justify-center nav-active"
                : "flex flex-col nav-btn justify-center"
            }
            to="/"
          >
            <img src="assets/images/home.svg" alt="" />
            <p><T text="Home" /></p>
          </NavLink>

          <NavLink
            className={({ isActive }) =>
              isActive
                ? "flex flex-col nav-btn justify-center nav-active"
                : "flex flex-col nav-btn justify-center"
            }
            to={"/chats"}
          >
            <img src="assets/images/chats.svg" alt="" />
            <p><T text="Chats" /></p>
          </NavLink>

          <NavLink
            className={({ isActive }) =>
              isActive
                ? "flex flex-col nav-btn justify-center nav-active"
                : "flex flex-col nav-btn justify-center"
            }
            to="/saved"
          >
            <img src="assets/images/heart.svg" alt="" />
            <p><T text="Saved" context="navigation" /></p>
          </NavLink>

          <NavLink
            className={({ isActive }) =>
              isActive
                ? "flex flex-col nav-btn justify-center nav-active"
                : "flex flex-col nav-btn justify-center"
            }
            to="/price"
          >
            <img src="assets/images/bill.svg" alt="" />
            <p><T text="Pricing" /></p>
          </NavLink>

          <NavLink
            className={({ isActive }) =>
              isActive
                ? "flex flex-col nav-btn audiobook-nav-btn justify-center nav-active"
                : "flex flex-col nav-btn audiobook-nav-btn justify-center"
            }
            to="/audiobooks"
            aria-label={this.context.t("Audiobooks")}
          >
            <HeadphonesIcon className="h-6 w-6" />
            <p className="audiobooks-nav-label"><T text="Audio" /><br /><T text="books" /></p>
          </NavLink>

          

          <NavLink
            className={({ isActive }) =>
              isActive
                ? "flex flex-col nav-btn justify-center nav-active"
                : "flex flex-col nav-btn justify-center"
            }
            to="/setting"
          >
            <img src="assets/images/setting.svg" alt="" />
            <p><T text="Settings" /></p>
          </NavLink>
        </div>
      </>
    );
  }
}

export default SideMenu;
